/* jQuery validator requires the showErrors to be in quotes, jscs doesn't allow this in objects
disabled jscs rule in handleApiErrorResponse
*/
'use strict';
import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import cookies from 'js-cookie';
import mediator from '../../js/mediator';
import RegistrationConfirmationModal from './RegistrationConfirmationModal';
import RegistrationFormModel from './RegistrationFormModel';
import config from '../../js/config';
import userService from '../../services/CartUserService';
import analytics from '../Analytics/Analytics';
import * as featureFlags from '../../utilities/featureFlags';
import CountriesAndStatesAPI from '../CountriesAndStates/CountriesAndStatesAPI';
import cartApi from '../../services/CartAPI';
import { getLogger } from 'loglevel';
import { jQueryRefreshToken } from '../../utilities/requestFetchMiddleware';
import cacheCookieHelper from '../../components/CacheCookieHelper/CacheCookieHelper';
import * as globalisation from '../../utilities/globalisation';
const log = getLogger('loginAPI');
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';
const countriesListEntryClassName = 'RegistrationForm-countryAutocompleteResults-entry';

const RegistrationFormView = Backbone.View.extend({
  events: {
    'click .js-togglePassword': 'togglePassword',
    'click #sameAsTermsAddress': 'toggleBillingAddress',
    'click #RegistrationForm-submitButton': 'onSubmit',
    'keyup #password': 'validatePassword',
    'keydown #phoneNumber': 'handleKeyDown',
    'change .RegistrationForm-email': 'removeDuplicateEmailError',
  },

  initialize: function() {
    $('.mtcaptcha').css('display', 'none');
    this.isApacRegion = '';
    this.pageLoad = true;
    this.$submitButton = this.$el.find('#RegistrationForm-submitButton');
    this.$email = $('.RegistrationForm-email');
    this.$password = this.$el.find('.RegistrationForm-password');
    if (featureFlags.EnableEUCFields.isEnabled()) {
      this.$phoneNumber = this.$el.find('.RegistrationForm-phoneNumber');
      this.$organizationName = this.$el.find('#organizationName');
      this.$organizationWebsite = this.$el.find('#organizationWebsite');
      this.$jobTitle = this.$el.find('#jobTitle');
      this.$market = this.$el.find('#market');
      this.$businessType = this.$el.find('#businessType');
      this.$businessServe = this.$el.find('#businessServe');
      this.$reqErrMesgJobTitle = this.$el.find('#reqErrMesgJobTitle');
      this.$reqErrMesgMarket = this.$el.find('#reqErrMesgMarket');
      this.$reqErrMesgBusinessType = this.$el.find('#reqErrMesgBusinessType');
      this.$reqErrMesgBusinessServe = this.$el.find('#reqErrMesgBusinessServe');
      this.$reqErrMesgJobTitle.hide();
      this.$reqErrMesgMarket.hide();
      this.$reqErrMesgBusinessType.hide();
      this.$reqErrMesgBusinessServe.hide();
      this.$jobTitleLabel = this.$jobTitle.closest('.u-form-input--text').find('label');
      this.$marketLabel = this.$market.closest('.u-form-input--text').find('label');
      this.$businessTypeLabel = this.$businessType.closest('.u-form-input--text').find('label');
      this.$businessServeLabel = this.$businessServe.closest('.u-form-input--text').find('label');
    }
    this.$terms = this.$el.find('.RegistrationForm-terms');
    this.$billing = this.$el.find('.RegistrationForm-billing');
    this.$createButtonSection = this.$el.find('*[data-create-account-button-section]');
    this.$goTo = this.$el.find('[name="goto"]');
    this.$goToOnFail = this.$el.find('[name="gotoOnFail"]');
    this.$termsAccount = this.$el.find('.RegistrationForm-myArrowTermsAccount');
    this.$forgottenAccount = $('.loginFail');
    this.$termsAccount.removeProp('disabled');
    this.$retypePassword = this.$el.find('#retypePassword');
    this.$fullName = this.$el.find('#fullName');
    $('#length, #number, #uppercase, #lowercase, #special-character').addClass('invalid');
    this.GDPRConsentErrorMessage = globalisation.pluraliseAndTranslate('account', 'gdprConsentValidation');
    if (featureFlags.EnableEUCFields.isEnabled()) {
      this.selectJobTitleLabel = globalisation.pluraliseAndTranslate('account', 'jobTitleErrorMsg');
      this.selectIndustryLabel = globalisation.pluraliseAndTranslate('account', 'marketErrorMsg');
      this.selectBusinessTypeLabel = globalisation.pluraliseAndTranslate('account', 'businessTypeErrorMsg');
      this.selectBusinessServeLabel = globalisation.pluraliseAndTranslate('account', 'typesofBusinessesErrorMsg');
    }
    // Currently on this registration form, it will always be from Arrow.com for the action.
    // When long form is enabled this will have to be dynamic.
    this.analyticsRegistrationEventSuccess = {
      event: config.analytics.registrationEvent.category,
      category: config.analytics.registrationEvent.category,
      action: config.analytics.registrationEvent.actionArrow,
      label: config.analytics.registrationEvent.labelSuccess
    };
    this.analyticsRegistrationEmailTracking = {
      event: config.analytics.registrationEvent.eventEmail,
      category: config.analytics.registrationEvent.categoryEmail,
      action: '', // Fill this property with country name
      label: '' // Fill this property with value of the marketing communication checkbox
    };
    this.analyticsRegistrationEventFail = Object.create(this.analyticsRegistrationEventSuccess);
    this.analyticsRegistrationEventFail.label = config.analytics.registrationEvent.labelFail;

    this.$countryContainer = this.$el.find('.RegistrationForm-countryContainer');
    this.$countryInput = this.$el.find('#RegistrationForm-country');
    if (featureFlags.EnableEUCFields.isEnabled()) {
      this.$countryMobileInput = this.$el.find('#RegistrationForm-countryMobileForEUC');
    } else {
      this.$countryMobileInput = this.$el.find('#RegistrationForm-countryMobile');
    }
    this.$countryAutocompleteResults = this.$el.find('#RegistrationForm-countryAutocompleteResults');
    this.$countryCodeInput = this.$el.find('#RegistrationForm-countryCode');
    this.$marketingOptIn = this.$el.find('#RegistrationForm-marketing');
    this.$loyaltyOptIn = this.$el.find('#RegistrationForm-loyaltyOptIn');

    this.countries = [];
    this.initializeCountries();
    // this.initializeMarketingOptIn();
    this.countriesListClickHandler = this.countriesListClicked.bind(this);
    this.$countryInput.on('keydown', this.countryInputKeyDown.bind(this));
    this.$countryInput.on('keyup', this.countryInputKeyUp.bind(this));
    this.$countryContainer.on('keydown', this.stopPropagation);
    this.$countryContainer.on('keyup', this.stopPropagation);
    this.$countryAutocompleteResults.on('keydown', this.countriesListKeyDown.bind(this));
    this.$countryMobileInput.on('change', this.countriesMobileInputChanged.bind(this));
    if (featureFlags.EnableEUCFields.isEnabled()) {
      this.$jobTitle.on('change', this.eucSelectFields.bind(this));
      this.$market.on('change', this.eucSelectFields.bind(this));
      this.$businessType.on('change', this.eucSelectFields.bind(this));
      this.$businessServe.on('change', this.eucSelectFields.bind(this));
    }
    $('body').on('click', this.countriesListDisable.bind(this));
    this.$gdprPrivacyConsent = this.$el.find('#RegistrationForm-policyContainer');
    $(this.$gdprConsentInput).prop('checked', false);
    this.$gdprConsentInput = this.$el.find('#RegistrationForm-GDPRConsent');
    this.$gdprConsentInput.on('change', this.gdprConsentInputChanged.bind(this));
    this.$gdprPrivacyConsentLabel = this.$gdprPrivacyConsent.find('label');
    this.gdprConsentName = this.$gdprPrivacyConsentLabel.find('input[type="checkbox"]').attr('name');
    if (this.$retypePassword['0']) {
      this.$retypePassword['0'].onpaste = function() { return false; };
    }
    this.perksOptIn = false;
    this.reCaptchaToken = '';
    this.mtCaptchaToken = '';
    this.token = this.getQueryParam('token');
    mediator.on(config.events.registration.reCaptchaSucess, this.reCaptchaSuccessCallback, this);
    mediator.on(config.events.registration.mtCaptchaSucess, this.mtCaptchaSuccessCallback, this);
    window.onReCaptchaSubmit = this.reCaptchaCallback;
    window.onMTCaptchaSubmit = this.mtCaptchaCallback;
    if (EnableAdobeAnalytics.isEnabled()) {
      analytics.pushFormInteractionData('form_start', 'Create Account');
    }
    this.$fullName.focus();
  },

  getQueryParam: function(param, url = window.location.href) {
    param = param.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  toggleBillingAddress: function(e) {

    var $target;
    if (this.$terms.length && this.$billing.length) {
      $target = $(e.currentTarget);
      if ($target[0].checked) {
        // Loop through all the inputs and get there values and names.
        _.each(this.$terms.find('.js-copy'), function(el) {
          var $el = $(el),
            val = $el.val(),
            name = $el.attr('name');
          this.$billing.find('input[name="' + name + '"]').val(val);
        }, this);
      } else {
        this.$billing.find('input').val('');
      }
    }
  },
  toggleSelectErrMesg: function() {
    this.$el.find('select[required]').each((_, select) => {
      const selectedValue = $(select).val();
      const isValidSelect = selectedValue && selectedValue.trim() !== '';
      if (!isValidSelect) {
        if (select.id.includes('jobTitle')) {
          this.$reqErrMesgJobTitle.show();
          this.$jobTitle.addClass('is-invalid selectFieldInvalid');
          this.$jobTitleLabel.addClass('is-invalid');
          this.$jobTitle.attr('aria-describedby', 'jobTitle-error');
          this.$jobTitle.attr('aria-invalid', 'true');
          $('#reqErrMesgJobTitle').html(this.selectJobTitleLabel);
        } else if (select.id.includes('market')) {
          this.$reqErrMesgMarket.show();
          this.$market.addClass('is-invalid selectFieldInvalid');
          this.$marketLabel.addClass('is-invalid');
          this.$market.attr('aria-describedby', 'market-error');
          this.$market.attr('aria-invalid', 'true');
          $('#reqErrMesgMarket').html(this.selectIndustryLabel);
        } else if (select.id.includes('businessType')) {
          this.$reqErrMesgBusinessType.show();
          this.$businessType.addClass('is-invalid selectFieldInvalid');
          this.$businessTypeLabel.addClass('is-invalid');
          this.$businessType.attr('aria-describedby', 'businessType-error');
          this.$businessType.attr('aria-invalid', 'true');
          $('#reqErrMesgBusinessType').html(this.selectBusinessTypeLabel);
        } else if (select.id.includes('businessServe')) {
          this.$reqErrMesgBusinessServe.show();
          this.$businessServe.addClass('is-invalid selectFieldInvalid');
          this.$businessServeLabel.addClass('is-invalid');
          this.$businessServe.attr('aria-describedby', 'businessServe-error');
          this.$businessServe.attr('aria-invalid', 'true');
          $('#reqErrMesgBusinessServe').html(this.selectBusinessServeLabel);
        }
      }
    });
  },
  getErrorMessages: function(validationType) {
    let error_messages = [];
    if (validationType === 'formValidation') {
      let $errorSpan = this.$el.find('.is-invalid').filter('span');
      let $errorLabel = this.$el.find('.is-invalid').filter('label');
      let gdprConsentChkBox = this.$gdprPrivacyConsentLabel.hasClass('is-invalid') || undefined;
      $errorSpan.each(function () {
        let $span = $(this);
        if ($span.css('display') === 'block') {
          let errorMessage = $span.text().trim() || undefined;
          error_messages.push({
            error_message: errorMessage,
            form_field_type: ''
          });
        }
      });
      $errorLabel.each(function (index) {
        let $label = $(this);
        let formFieldLabel = $label[0].innerText.trim() || undefined;
        error_messages[index].form_field_type = formFieldLabel.split('-')[0].trim() || undefined;
      });
      if (gdprConsentChkBox) {
        error_messages[error_messages.length - 1].form_field_type = this.gdprConsentName || undefined;
      }
    } else {
      if (validationType === 'apiValidation') {
        if (this.$forgottenAccount.css('display') === 'block') {
          error_messages.push({
            error_message: this.$forgottenAccount[0].innerText.trim() || undefined,
            form_field_type: undefined
          });
        }
      }
    }
    return error_messages;
  },
  toggleGDPRPrivacyConsentStatement: function(el) {
    if ($(el).is(':checked')) {
      this.$gdprPrivacyConsent.removeClass('is-invalid');
      this.$gdprPrivacyConsentLabel.removeClass('is-invalid');
      $('#GDPRPrivacyConsentError').hide();
      $('#GDPRPrivacyConsentError').removeClass('is-invalid error-message-icon');
      this.$gdprConsentInput.removeClass('is-invalid');
    }
    else {
      this.$gdprPrivacyConsent.addClass('is-invalid');
      this.$gdprPrivacyConsentLabel.addClass('is-invalid');
      $('#GDPRPrivacyConsentError').show();
      $('#GDPRPrivacyConsentError').addClass('is-invalid error-message-icon');
      $('#GDPRPrivacyConsentError').html(this.GDPRConsentErrorMessage);
      this.$gdprConsentInput.addClass('is-invalid');
    }
  },

  gdprConsentInputChanged: function(e) {
    this.toggleGDPRPrivacyConsentStatement(e.currentTarget);
  },

  togglePassword: function(e) {
    e.preventDefault();
    var $target = $(e.currentTarget),
      $input = e.currentTarget.parentElement.querySelector('input');

    if ($target.hasClass(config.classes.isActive)) {
      $input.type = 'password';
      $target.removeClass(config.classes.isActive);
      e.target.previousElementSibling.focus(e.target);
    } else {
      $input.type = 'text';
      $target.addClass(config.classes.isActive);
      e.target.nextElementSibling.focus(e.target);
    }
  },
  validatePassword: function(e) {
    e.preventDefault();
    this.$password = this.$el.find('#password').val();
    this.$el.find('#icon-length').addClass(this.passwordRequirement('icon', 'length'));
    this.$el.find('#icon-number').addClass(this.passwordRequirement('icon', 'number'));
    this.$el.find('#icon-uppercase').addClass(this.passwordRequirement('icon', 'uppercase'));
    this.$el.find('#icon-lowercase').addClass(this.passwordRequirement('icon', 'lowercase'));
    this.$el.find('#icon-special-character').addClass(this.passwordRequirement('icon', 'special-character'));

    this.$el.find('#length').addClass(this.passwordRequirement('message', 'length'));
    this.$el.find('#number').addClass(this.passwordRequirement('message', 'number'));
    this.$el.find('#uppercase').addClass(this.passwordRequirement('message', 'uppercase'));
    this.$el.find('#lowercase').addClass(this.passwordRequirement('message', 'lowercase'));
    this.$el.find('#special-character').addClass(this.passwordRequirement('message', 'special-character'));
  },
  handleKeyDown: function(e) {
    if (!featureFlags.EnableEUCFields.isEnabled()) {
      return;
    }
    if (e.which === 32) {
      e.preventDefault();
    }
  },
  validateEUCSelectFields: function() {
    let isAllSelectEUCFieldValid = true;
    this.$el.find('select[required]').each((_, select) => {
      const selectedValue = $(select).val();
      const isValidSelect = selectedValue && selectedValue.trim() !== '';
      if (!isValidSelect) {
        isAllSelectEUCFieldValid = false;
      }
    });
    return isAllSelectEUCFieldValid;
  },
  passwordRequirement: function(type, toCheck) {
    this.$password = this.$el.find('#password').val();
    var className;
    if (type === 'message') {
      switch (toCheck) {
        case 'length': {
          this.$el.find('#length').removeClass();
          className = this.$password.length >= 12 && this.$password.length <= 25 ? 'valid' : 'invalid';
          break;
        }
        case 'number': {
          this.$el.find('#number').removeClass();
          className = /[0-9]/g.test(this.$password) ? 'valid' : 'invalid';
          break;
        }
        case 'uppercase': {
          this.$el.find('#uppercase').removeClass();
          className = /[A-Z]/g.test(this.$password) ? 'valid' : 'invalid';
          break;
        }
        case 'lowercase': {
          this.$el.find('#lowercase').removeClass();
          className = /[a-z]/g.test(this.$password) ? 'valid' : 'invalid';
          break;
        }
        case 'special-character': {
          this.$el.find('#special-character').removeClass();
          className = /[~!@#$%^*()\-_=+[\]|;:,.<>/?]/g.test(this.$password) ? 'valid' : 'invalid';
          break;
        }
      }
      return className;
    } else {
      switch (toCheck) {
        case 'length': {
          this.$el.find('#icon-length').removeClass();
          className = this.$password.length >= 12 && this.$password.length <= 25 ? 'icon-check' : 'icon-dot';
          break;
        }
        case 'number': {
          this.$el.find('#icon-number').removeClass();
          className = /[0-9]/g.test(this.$password) ? 'icon-check' : 'icon-dot';
          break;
        }
        case 'uppercase': {
          this.$el.find('#icon-uppercase').removeClass();
          className = /[A-Z]/g.test(this.$password) ? 'icon-check' : 'icon-dot';
          break;
        }
        case 'lowercase': {
          this.$el.find('#icon-lowercase').removeClass();
          className = /[a-z]/g.test(this.$password) ? 'icon-check' : 'icon-dot';
          break;
        }
        case 'special-character': {
          this.$el.find('#icon-special-character').removeClass();
          className = /[~!@#$%^*()\-_=+[\]|;:,.<>/?]/g.test(this.$password) ? 'icon-check' : 'icon-dot';
          break;
        }
      }
      return className;
    }
  },
  initializeCountries: function() {
    CountriesAndStatesAPI.getCmsCountriesAndStates().then(countries => {
      this.countries = countries;
      this.$countryMobileInput[0].innerHTML = '<option value=""></option>';
      countries.forEach(country => {
        this.$countryMobileInput[0].innerHTML += `<option value=${country.Iso2Code}>${country.CountryName}</option>`;
      });
      let geoCountry = this.getGeoCountry();
      if (geoCountry) {
        this.$countryMobileInput.val(geoCountry);
        this.$countryMobileInput.change();
      }
    });
  },

  initializeMarketingOptIn: function() {
    let geoCountry = this.getGeoCountry();
    let countriesMarketingDisabledByDefault = this.$el[0].dataset.countriesDisabled;
    this.$marketingOptIn.prop('checked', false);
    if (countriesMarketingDisabledByDefault) {
      if (countriesMarketingDisabledByDefault.split(',').indexOf(geoCountry) === -1) {
        this.$marketingOptIn.prop('checked', true);
      }
    }
  },

  getGeoCountry: function() {
    let dataLayerEntries = window.dataLayer && window.dataLayer.filter(item => item.user && item.user.profile && item.user.profile.userGeo);
    let countryCode = null;
    if (dataLayerEntries && dataLayerEntries.length) {
      countryCode = dataLayerEntries[0].user.profile.userGeo;
    }
    return countryCode;
  },

  countriesAutocompleteToShow: function(inputValue) {
    return this.countries.filter(country => {
      return (inputValue.toLowerCase() === country.CountryName.slice(0, inputValue.length).toLowerCase());
    });
  },
  checkGDPREnabledCountry: function() {
    if (this.$countryCodeInput) {
      let country = _.find(this.countries, entry => entry.Iso2Code === this.$countryCodeInput.val());
      if (country) {
        return country.GDPREnabled;
      }
    }
    return false;
  },

  countryInputKeyDown: function(e) {
    var keyCode = e.keycode || e.which;
    if (this.$countryAutocompleteResults.is(':visible')) {
      let firstChild = $('#RegistrationForm-countryAutocompleteResults li').first();
      if (firstChild) {
        if (keyCode === config.key.down) {
          e.preventDefault();
          this.$countryAutocompleteResults.attr('tabindex', '13')
            .focus();
          this.$countryAutocompleteResults.attr('aria-activedescendant', firstChild.attr('id'));
          firstChild.addClass('selected');
        }
        else if (keyCode === config.key.tab) {
          this.countriesListClose();
        }
      }
    }

    if (keyCode === config.key.up || keyCode === config.key.down || keyCode === config.key.escape) {
      this.cancelEvent(e);
      return false;
    }
  },

  countryInputKeyUp: function(e) {
    var keyCode = e.keycode || e.which;
    if (keyCode === config.key.up || keyCode === config.key.escape) {
      this.cancelEvent(e);
      return false;
    }
    else if (keyCode === config.key.tab) {
      this.countriesListClose();
    }
    else {
      let inputValue = this.$countryInput[0].value;
      let countriesList = this.countriesAutocompleteToShow(inputValue);
      this.$countryAutocompleteResults[0].innerHTML = '';
      this.$countryCodeInput.val('');
      $(`.${countriesListEntryClassName}`).off('click', this.countriesListClickHandler);
      if (inputValue && countriesList.length) {
        for (let i = 0; i < countriesList.length; i++) {
          let id = 'countryListItem-' + i;
          this.$countryAutocompleteResults[0].innerHTML += `<li role='option' id=${id} class=${countriesListEntryClassName} data-code=${countriesList[i].Iso2Code}>${countriesList[i].CountryName}</li>`;
        }
        $(`.${countriesListEntryClassName}`).on('click', this.countriesListClickHandler);
        this.$countryAutocompleteResults.show();
        this.$countryInput.attr('aria-expanded', true);
        this.removeInvalidCountryError();
      } else {
        this.countriesListClose();
      }
    }
  },

  countriesMobileInputChanged: function(e) {
    let countryCode = e.target.value;
    let countryName = e.target.options[e.target.selectedIndex].text;

    this.$countryInput.val(countryName);
    this.$countryCodeInput.val(countryCode);
  },
  eucSelectFields: function(e) {
    let selectedValue = e.target.value;
    if (e.target === this.$jobTitle[0] && selectedValue === '') {
      if (this.$el.find('#jobTitle-error').length > 0) {
        this.$el.find('#jobTitle-error').hide();
      }
      this.$reqErrMesgJobTitle.show();
      this.$jobTitle.addClass('is-invalid selectFieldInvalid');
      this.$jobTitleLabel.addClass('is-invalid');
      this.$jobTitle.attr('aria-describedby', 'jobTitle-error');
      this.$jobTitle.attr('aria-invalid', 'true');
      $('#reqErrMesgJobTitle').html(this.selectJobTitleLabel);
    } else {
      if (e.target === this.$jobTitle[0] && selectedValue !== '') {
        this.$reqErrMesgJobTitle.hide();
        this.$jobTitleLabel.removeClass('is-invalid');
        this.$jobTitle.removeClass('is-invalid selectFieldInvalid');
        this.$jobTitle.attr('aria-invalid', 'false');
      }
    }
    if (e.target === this.$market[0] && selectedValue === '') {
      if (this.$el.find('#market-error').length > 0) {
        this.$el.find('#market-error').hide();
      }
      this.$reqErrMesgMarket.show();
      this.$market.addClass('is-invalid selectFieldInvalid');
      this.$marketLabel.addClass('is-invalid');
      this.$market.attr('aria-describedby', 'market-error');
      this.$market.attr('aria-invalid', 'true');
      $('#reqErrMesgMarket').html(this.selectIndustryLabel);
    } else {
      if (e.target === this.$market[0] && selectedValue !== '') {
        this.$reqErrMesgMarket.hide();
        this.$marketLabel.removeClass('is-invalid');
        this.$market.removeClass('is-invalid selectFieldInvalid');
        this.$market.attr('aria-invalid', 'false');
      }
    }
    if (e.target === this.$businessType[0] && selectedValue === '') {
      if (this.$el.find('#businessType-error').length > 0) {
        this.$el.find('#businessType-error').hide();
      }
      this.$reqErrMesgBusinessType.show();
      this.$businessType.addClass('is-invalid selectFieldInvalid');
      this.$businessTypeLabel.addClass('is-invalid');
      this.$businessType.attr('aria-describedby', 'businessType-error');
      this.$businessType.attr('aria-invalid', 'true');
      $('#reqErrMesgBusinessType').html(this.selectBusinessTypeLabel);
    } else {
      if (e.target === this.$businessType[0] && selectedValue !== '') {
        if (this.$el.find('#businessServe-error')) {
          this.$el.find('#businessServe-error').hide();
        }
        this.$reqErrMesgBusinessType.hide();
        this.$businessTypeLabel.removeClass('is-invalid');
        this.$businessType.removeClass('is-invalid selectFieldInvalid');
        this.$businessType.attr('aria-invalid', 'false');
      }
    }
    if (e.target === this.$businessServe[0] && selectedValue === '') {
      if (this.$el.find('#businessServe-error').length > 0) {
        this.$el.find('#businessServe-error').hide();
      }
      this.$reqErrMesgBusinessServe.show();
      this.$businessServe.addClass('is-invalid selectFieldInvalid');
      this.$businessServeLabel.addClass('is-invalid');
      this.$businessServe.attr('aria-describedby', 'businessServe-error');
      this.$businessServe.attr('aria-invalid', 'true');
      $('#reqErrMesgBusinessServe').html(this.selectBusinessServeLabel);
    } else {
      if (e.target === this.$businessServe[0] && selectedValue !== '') {
        this.$reqErrMesgBusinessServe.hide();
        this.$businessServeLabel.removeClass('is-invalid');
        this.$businessServe.removeClass('is-invalid selectFieldInvalid');
        this.$businessServe.attr('aria-invalid', 'false');
      }
    }
  },

  cancelEvent: function(e) {
    e = e || window.event;
    if (e !== null) {
      if (e.cancelBubble) {
        e.cancelBubble = true;
      }
      e.preventDefault();
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  },

  stopPropagation: function(e) {
    e = e || window.event;
    if (e !== null) {
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  },

  countriesListKeyDown: function(e) {
    var keyCode = e.keycode || e.which;
    if (keyCode === config.key.enter) {
      let $target = $('#RegistrationForm-countryAutocompleteResults li.selected');
      if ($target && $target.length) {
        let countryCode = $target[0].dataset.code;
        let countryName = $target[0].textContent;
        this.$countryMobileInput.val(countryCode);
        this.$countryInput.val(countryName);
        this.$countryCodeInput.val(countryCode);
        this.countriesListClose();
      }
      this.cancelEvent(e);
      this.$countryInput[0].focus();
      return false;
    }
    else if (keyCode === config.key.escape) {
      this.cancelEvent(e);
      this.countriesListClose();
      this.$countryInput[0].focus();
      return false;
    }
    else if (keyCode === config.key.tab) {
      this.countriesListClose();
    }
    else {
      var newOption;
      if (keyCode === config.key.down) {
        newOption = $('#RegistrationForm-countryAutocompleteResults li.selected').next();
      }
      else if (keyCode === config.key.up) {
        newOption = $('#RegistrationForm-countryAutocompleteResults li.selected').prev();
        if (!(newOption && newOption.length)) {
          this.cancelEvent(e);
          this.countriesListClose();
          this.$countryInput[0].focus();
        }
      }

      if (newOption && newOption.length) {
        this.cancelEvent(e);
        $('#RegistrationForm-countryAutocompleteResults .selected').removeClass('selected');
        newOption.addClass('selected');
        this.$countryAutocompleteResults.attr('aria-activedescendant', newOption.attr('id'));
      }
    }
  },

  countriesListClicked: function(e) {
    let countryCode = e.target.dataset.code;
    let countryName = e.target.textContent;

    this.$countryMobileInput.val(countryCode);
    this.$countryInput.val(countryName);
    this.$countryCodeInput.val(countryCode);
    this.countriesListClose();
    e.stopPropagation();
  },

  countriesListDisable: function() {
    this.$countryAutocompleteResults.hide();
  },

  countriesListClose: function() {
    this.$countryAutocompleteResults.hide();

    let $list = $('#RegistrationForm-countryAutocompleteResults li');
    if (this.$countryInput && $list && $list.length) {
      this.$countryInput.attr('aria-expanded', false);
    }
    if (this.$countryAutocompleteResult) {
      this.$countryAutocompleteResults.removeAttr('aria-activedescendant');
    }
  },

  getGotoUrl: function() {
    if (featureFlags.EnableLoyaltyMVP.isEnabled() && this.perksOptIn) {
      return featureFlags.EnableLoyaltyPoints.isEnabled() && document.location.href.toLowerCase().indexOf('cartloyalty=true') >= 0 ? config.urls.cart.cart : config.urls.users.perks;

    } else {
      return this.$goTo.val();
    }
  },

  validateGDPRConsent: function() {
    return (this.$gdprConsentInput && !(this.$gdprConsentInput).is(':checked'));
  },

  reCaptchaCallback(token) {
    mediator.trigger(config.events.registration.reCaptchaSucess, token);
  },

  mtCaptchaCallback(state) {
    mediator.trigger(config.events.registration.mtCaptchaSucess, state.verifiedToken);
  },

  mtCaptchaSuccessCallback(token) {
    this.mtCaptchaToken = token;
    if (!this.pageLoad) {
      this.registerUser();
    }
  },

  reCaptchaSuccessCallback(token) {
    this.reCaptchaToken = token;
    if (this.$submitButton.hasClass('RegistrationForm-submitButtonHidden')) {
      this.$submitButton.removeClass('RegistrationForm-submitButtonHidden');
    }
    else {
      this.registerUser();
    }
  },
  registerUser: function() {
    if ((featureFlags.EnableReCaptcha.isEnabled() && this.reCaptchaToken) ||
      (featureFlags.EnableMTCaptcha.isEnabled() && this.mtCaptchaToken) ||
      !featureFlags.EnableReCaptcha.isEnabled()) {
      this.toggleLoadingIndicator(true);
      this.removeDuplicateEmailError();
      if (this.$countryCodeInput) {
        if (!this.$countryCodeInput.val()) {
          this.$countryInput.addClass(config.classes.hasCustomValidationError);
          this.toggleLoadingIndicator(false);
        } else {
          this.$countryInput.removeClass(config.classes.hasCustomValidationError);
        }
      }
      if (this.$gdprConsentInput) {
        this.toggleGDPRPrivacyConsentStatement(this.$gdprConsentInput);
      }
      _.each(this.$('[data-form]'), function(input) {
        var $input = $(input),
          name = $input.data('form'),
          value = $input.val();
        if (name === 'loyaltyOptIn') {
          value = $input.is(':checked');
          this.perksOptIn = value;
        }
        this.model.set(name, value);
      }, this);
      if (featureFlags.EnableReCaptcha.isEnabled() && this.reCaptchaToken) {
        this.model.set('reCaptchaToken', this.reCaptchaToken);
      }
      if (featureFlags.EnableMTCaptcha.isEnabled() && this.mtCaptchaToken) {
        this.model.set('mtCaptchaToken', this.mtCaptchaToken);
      }
      if (this.token) {
        this.model.set('token', this.token);
      }
      // Set the User Name
      userService.setUserName(document.getElementsByClassName('RegistrationForm-email')[0].textContent);
      this.model.set('emailId', document.getElementsByClassName('RegistrationForm-email')[0].textContent);
      // Set the first and last name
      userService.setFirstAndLastNameFromFullName(this.model.attributes.fullName);
      return this.model.set({
        firstname: userService.firstname,
        lastname: userService.lastname
      })
        .save()
        .then((registrationResponse) => {
          $('.mtcaptcha').css('display', 'none');
          // add registration
          if (!registrationResponse.data.success) {
            if (EnableAdobeAnalytics.isEnabled()) {
              analytics.pushFormErrorData('Create Account', this.getErrorMessages('apiValidation'));
            }
            if (this.isApacRegion === 'false') {
              if (featureFlags.EnableReCaptcha.isEnabled() && grecaptcha) {
                grecaptcha.reset();
              }
            }
            if (!this.$el.valid() || this.validateGDPRConsent()) {
              this.toggleLoadingIndicator(false);
              // Emit event of a failed registration to analytics
              analytics.emitNewDataLayerEvent(this.analyticsRegistrationEventFail);
            }
            if (registrationResponse.data.message.errorCode === config.events.forgotPassword.userAllreadyExists) {
              this.toggleLoadingIndicator(false);
              return registrationResponse;
            } else if (registrationResponse.data.message.errorCode === config.events.forgotPassword.externalForgottenUser) {
              this.$forgottenAccount.addClass(config.classes.isActive);
              this.toggleLoadingIndicator(false);
              return registrationResponse;
            }
          }
          else if (featureFlags.EnableHybrisIntegration.isEnabled() && registrationResponse.data.success && registrationResponse.arrowfed) {
            cookies.set(config.cookies.accessToken, '', { domain: config.cookies.domain });
            cookies.set(config.cookies.arrowFed, registrationResponse.arrowfed, { domain: config.cookies.domain });
            if (cacheCookieHelper) {
              cacheCookieHelper.setCacheCookie();
            }
            return jQueryRefreshToken()
              .then(() => {
                let d = $.Deferred();
                cartApi.mergeCart().then(
                  () => {
                    d.resolve(registrationResponse);
                  },
                  () => {
                    log.error('merge cart fail');
                    d.resolve(registrationResponse);
                  });
                return d.promise();
              }).then(() => {
                return registrationResponse;
              });
          }
          else {
            return registrationResponse;
          }
        })
        .then(_.bind(function(registrationResponse) {
          if (registrationResponse.data.success) {
            this.toggleLoadingIndicator(false);
            if (EnableAdobeAnalytics.isEnabled()) {
              analytics.adobeAccountData(document.getElementsByClassName('RegistrationForm-email')[0].textContent, 'account_CreateComplete');
              analytics.pushFormInteractionData('form_submit', 'Create Account');
            }
            else {
              // Emit event of a successful registration to analytics
              analytics.emitNewDataLayerEvent(this.analyticsRegistrationEventSuccess);
            }
            //marketting tracking by GA
            this.analyticsRegistrationEmailTracking.action = this.$countryInput && this.$countryInput.val();
            this.analyticsRegistrationEmailTracking.label = config.analytics.registrationEvent.labelPrefix + (this.$marketingOptIn && this.$marketingOptIn.is(':checked'));
            analytics.emitNewDataLayerEvent(this.analyticsRegistrationEmailTracking);
            new RegistrationConfirmationModal();
            window.localStorage.currentUserFirstName = userService.firstname;
            if (featureFlags.EnableLoyaltyMVP.isEnabled() && this.perksOptIn) {
              analytics.emitNewDataLayerEvent(this.analyticsPerksOptInEventSuccess);
            }
            if (featureFlags.EnableEUCFields.isEnabled()) {
              mediator.trigger(config.events.registration.confirmation, {
                advancedForm: this.advancedForm,
                email: document.getElementsByClassName('RegistrationForm-email')[0].textContent,
                firstName: userService.firstname,
                lastName: userService.lastname,
                optIn: this.$marketingOptIn && this.$marketingOptIn.is(':checked'),
                country: this.$countryCodeInput && this.$countryCodeInput.val(),
                goTo: this.getGotoUrl(),
                goToOnFail: this.$goToOnFail.val(),
                phoneNumber: this.$phoneNumber.val().length > 0 ? this.$phoneNumber.val().replace(/\s+/g, '') : undefined,
                companyName: this.$organizationName.val().length > 0 ? this.$organizationName.val() : undefined,
                companyWebsite: this.$organizationWebsite.val().length > 0 ? this.$organizationWebsite.val() : undefined,
                jobType: this.$jobTitle.val().length > 0 ? this.$jobTitle.val() : undefined,
                industry: this.$market.val().length > 0 ? this.$market.val() : undefined,
                business: this.$businessType.val().length > 0 ? this.$businessType.val() : undefined,
                businessServed: this.$businessServe.val().length > 0 ? this.$businessServe.val(): undefined,
                password: document.getElementById('password').value,
                privacyTermsOptIn: this.$gdprConsentInput && this.$gdprConsentInput.is(':checked'),
                loyaltyStatus: this.$loyaltyOptIn && this.$loyaltyOptIn.is(':checked')
              });
            } else {
              mediator.trigger(config.events.registration.confirmation, {
                advancedForm: this.advancedForm,
                email: document.getElementsByClassName('RegistrationForm-email')[0].textContent,
                firstName: userService.firstname,
                lastName: userService.lastname,
                optIn: this.$marketingOptIn && this.$marketingOptIn.is(':checked'),
                country: this.$countryCodeInput && this.$countryCodeInput.val(),
                goTo: this.getGotoUrl(),
                goToOnFail: this.$goToOnFail.val(),
                password: document.getElementById('password').value,
                privacyTermsOptIn: this.$gdprConsentInput && this.$gdprConsentInput.is(':checked'),
                loyaltyStatus: this.$loyaltyOptIn && this.$loyaltyOptIn.is(':checked')
              });
            }
          }
        }, this), _.bind(function() {
          this.toggleLoadingIndicator(false);
          // Emit event of a failed registration to analytics
          analytics.emitNewDataLayerEvent(this.analyticsRegistrationEventFail);
        }, this));
    }
  },

  onSubmit: function(e) {
    e.preventDefault();
    this.isApacRegion = document.getElementById('region').value;
    if (featureFlags.EnableEUCFields.isEnabled()) {
      let isSelectFieldsValid = this.validateEUCSelectFields();
      if (!this.$el.valid() || this.validateGDPRConsent() || !isSelectFieldsValid) {
        if (this.validateGDPRConsent()) {
          this.toggleGDPRPrivacyConsentStatement(this.$gdprConsentInput);
        }
        if (!isSelectFieldsValid) {
          this.toggleSelectErrMesg();
        }
        let focusElm = null;
        if (!$('#fullName').val())
          focusElm = $('#fullName');
        else {
          if (!$('#RegistrationForm-countryMobileForEUC').val())
            focusElm = $('#RegistrationForm-countryMobileForEUC');
          else {
            if (!$('#phoneNumber').val())
              focusElm = $('#phoneNumber');
            else {
              if (!$('#organizationName').val())
                focusElm = $('#organizationName');
              else {
                if (!$('#organizationWebsite').val())
                  focusElm = $('#organizationWebsite');
                else {
                  if (!$('#jobTitle').val())
                    focusElm = $('#jobTitle');
                  else {
                    if (!$('#market').val())
                      focusElm = $('#market');
                    else {
                      if (!$('#businessType').val())
                        focusElm = $('#businessType');
                      else {
                        if (!$('#businessServe').val())
                          focusElm = $('#businessServe');
                        else {
                          if (!$('#password').val())
                            focusElm = $('#password');
                          else {
                            if (!$('#retypePassword').val())
                              focusElm = $('#retypePassword');
                            else {
                              ($('#RegistrationForm-GDPRConsent').is(':not(:checked)'))
                              focusElm = $('#RegistrationForm-GDPRConsent');
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if (focusElm)
          focusElm.focus();
        var isInValidInput = $('span.is-invalid');
        isInValidInput.addClass('error-message-icon');
        isInValidInput.each(function (index, item) {
          item.ariaLabel = globalisation.pluraliseAndTranslate('common', 'errorText') + ', ' + item.innerText;
        });
        analytics.pushFormErrorData('Create Account', this.getErrorMessages('formValidation'));
        return;
      }
    } else {
      if (!this.$el.valid() || this.validateGDPRConsent()) {
        if (this.validateGDPRConsent()) {
          this.toggleGDPRPrivacyConsentStatement(this.$gdprConsentInput);
        }
        let focusElm = null;
        if (!$('#fullName').val())
          focusElm = $('#fullName');
        else {
          if (!$('#password').val())
            focusElm = $('#password');
          else {
            if (!$('#retypePassword').val())
              focusElm = $('#retypePassword');
            else {
              ($('#RegistrationForm-GDPRConsent').is(':not(:checked)'))
              focusElm = $('#RegistrationForm-GDPRConsent');
            }
          }
        }
        if (focusElm)
          focusElm.focus();
        var isInValidInput = $('span.is-invalid');
        isInValidInput.addClass('error-message-icon');
        isInValidInput.each(function (index, item) {
          item.ariaLabel = globalisation.pluraliseAndTranslate('common', 'errorText') + ', ' + item.innerText;
        });
        analytics.pushFormErrorData('Create Account', this.getErrorMessages('formValidation'));
        return;
      }
    }
    if (this.isApacRegion === 'true') {
      this.pageLoad = false;
      $('.mtcaptcha').css('display', 'block');
      if (featureFlags.EnableMTCaptcha.isEnabled() && this.mtCaptchaToken) {
        this.registerUser();
      } else if (!featureFlags.EnableMTCaptcha.isEnabled()) {
        this.registerUser();
      }
    } else {
      featureFlags.EnableReCaptcha.isEnabled() && grecaptcha ? grecaptcha.execute() : this.registerUser();
    }
  },

  toggleLoadingIndicator: function(isLoading) {

    if (isLoading) {
      // although we set pointer-events on the loading class, blur it, too,
      //  to ensure return doesn't submit it
      this.$submitButton
        .addClass(config.classes.loadingClass)
        .blur();
    } else {
      this.$submitButton
        .removeClass(config.classes.loadingClass);
      if (this.isApacRegion === 'false') {
        if (featureFlags.EnableReCaptcha.isEnabled() && grecaptcha) {
          grecaptcha.reset();
        }
      }
    }
  },

  removeDuplicateEmailError: function removeDuplicateEmailError() {
    if (this.$forgottenAccount.hasClass(config.classes.isActive)) {
      this.$forgottenAccount.removeClass(config.classes.isActive);
    }
  },

  removeInvalidCountryError: function removeInvalidCountryError() {
    if (this.$countryInput.hasClass(config.classes.hasCustomValidationError)) {
      this.$countryInput.removeClass(config.classes.hasCustomValidationError);
    }
  }
},

{
  create: function($parent) {
    $parent.find('.RegistrationForm').each(function(n, el) {
      new RegistrationFormView({
        el: el,
        model: new RegistrationFormModel()
      });
    });
  }
});

module.exports = RegistrationFormView;



// WEBPACK FOOTER //
// ./assets/components/Registration/Registration.js